/**
 * Options for setting initial headers on an XMLHttpRequest.
 * @property customerId - Optional customer/organization ID to set in headers.
 * @property accessToken - Optional access token for Authorization header.
 * @property frontendVersion - Optional frontend version for client version header.
 */
export interface SetInitHeadersOptions {
    customerId?: string;
    accessToken?: string;
    frontendVersion?: string;
}

/**
 * Sets initial headers on an XMLHttpRequest for LumApps web client.
 *
 * @param initRequest - The XMLHttpRequest to set headers on.
 * @param options - Options for setting headers (customerId, accessToken, frontendVersion).
 * @returns The XMLHttpRequest with headers set.
 */
export const setInitHeaders = (initRequest: XMLHttpRequest, options: SetInitHeadersOptions): XMLHttpRequest => {
    initRequest.setRequestHeader('X-Lumapps-Analytics', 'on');

    if (options.customerId) {
        initRequest.setRequestHeader('Lumapps-Organization-Id', options.customerId);
    }

    initRequest.setRequestHeader('Lumapps-Web-Client-Version', options.frontendVersion || '');

    if (options.accessToken) {
        initRequest.setRequestHeader('Authorization', `Bearer ${options.accessToken}`);
    } else {
        initRequest.setRequestHeader(
            'LUMAPPS-PUBLIC-UNIQUE-ID',
            window.localStorage.getItem('LUMAPPS-PUBLIC-UNIQUE-ID') || '',
        );
    }

    return initRequest;
};
